import * as React from "react";
import ValidatorsLayout from "../components/ValidatorsLayout";

const ContainersValidators: React.FC = () => {
  return (
    <ValidatorsLayout />
  );
};

export default ContainersValidators;